import { JsonDecoder } from 'ts.data.json';
import { ExternalFirm } from './model';
import { usersByAdvisorDecoder } from '../users/decoder';
import { emailSettings } from '../firm/decoder';

export const externalFirmDecoder = JsonDecoder.object<ExternalFirm>(
    {
        id: JsonDecoder.number,
        accessGroupId: JsonDecoder.number,
        name: JsonDecoder.string,
        crdNumber: JsonDecoder.optional(JsonDecoder.string),
        type: JsonDecoder.string,
        addressStreet: JsonDecoder.optional(JsonDecoder.string),
        addressCity: JsonDecoder.optional(JsonDecoder.string),
        addressState: JsonDecoder.optional(JsonDecoder.string),
        addressZip: JsonDecoder.optional(JsonDecoder.string),
        users: JsonDecoder.optional(usersByAdvisorDecoder),
        emailSettings: JsonDecoder.optional(emailSettings)
    },
    'ExternalFirm'
);

export const externalFirmsDecoder = JsonDecoder.array<ExternalFirm>(
    externalFirmDecoder,
    'ExternalFirms'
);
